import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';

/**
 *  Infinite scroll/pagination component for page.
 */

@Component({
  selector: 'infinite-scroll-migrated',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './infinite-scroll.component.html',
  styleUrls: ['./infinite-scroll.component.scss'],
})
export class InfiniteScrollComponentMigrated implements OnChanges {
  @Output() getNextPage = new EventEmitter();

  @Input() classes = '';

  @Input() public isNextPageAvailable: boolean;

  infiniteScrollNextPageEvent; // The event from a "nextPage" function call. Need to hold a reference to it to be able to mark it complete.

  @Input() loading: boolean;

  /**
   * Emits an event telling the parent to get the next page of items.
   *
   * @param event - the event that will need to be marked as completed;
   */
  public nextPage(event) {
    // We need to mark the refresh as complete, so we'll save the event in our infiniteScrollNextPageEvent member variable.
    // When the loading input is changed to true, we'll call complete on the refresher.
    this.infiniteScrollNextPageEvent = event;
    this.getNextPage.emit();
  }

  ngOnChanges() {
    // if there is no longer a refresh in progress and there is a infiniteScrollNextPageEvent waiting to be marked as complete, mark it as complete.
    if (!this.loading && this.infiniteScrollNextPageEvent) {
      this.infiniteScrollNextPageEvent.target.complete();
      this.infiniteScrollNextPageEvent = null;
    }
  }
}
